var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.33333H7.88C7.6 0.56 6.86667 0 6 0C5.13333 0 4.4 0.56 4.12 1.33333H1.33333C0.6 1.33333 0 1.93333 0 2.66667V12C0 12.7333 0.6 13.3333 1.33333 13.3333H10.6667C11.4 13.3333 12 12.7333 12 12V2.66667C12 1.93333 11.4 1.33333 10.6667 1.33333ZM6 1.33333C6.36667 1.33333 6.66667 1.63333 6.66667 2C6.66667 2.36667 6.36667 2.66667 6 2.66667C5.63333 2.66667 5.33333 2.36667 5.33333 2C5.33333 1.63333 5.63333 1.33333 6 1.33333ZM6 4C7.10667 4 8 4.89333 8 6C8 7.10667 7.10667 8 6 8C4.89333 8 4 7.10667 4 6C4 4.89333 4.89333 4 6 4ZM10 12H2V11.0667C2 9.73333 4.66667 9 6 9C7.33333 9 10 9.73333 10 11.0667V12Z",
    fill: "#AAAAB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.86fbc518.svg";
export { ForwardRef as ReactComponent };